import { jsx as _jsx } from "react/jsx-runtime";
import Download16 from '@carbon/icons-react/es/download/16';
import { Button } from '@rocketlane/ui';
export const DownloadButton = (props)=>/*#__PURE__*/ _jsx(Button, {
        variant: "ghost",
        type: "button",
        rightIcon: /*#__PURE__*/ _jsx(Download16, {
            fill: "white"
        }),
        ...props
    });
